<!-- 特典を探す キーワード検索 -->
<template>
  <section class="crly-m-common-search-keyword crly-m-common-search-common">
    <CrlyAtomsCommonSearchTitle :title="$t('search.keyword.title')" />
    <div class="crly-m-common-search-common__contents">
      <CrlyMoleculesCommonSearchKeywordCategory
        @changeActiveCategory="changeActiveCategory"
      />
      <CrlyMoleculesCommonSearchKeywordInputForm
        @clickSearchBtn="clickSearchBtn"
        @focusoutKeyword="focusoutKeyword"
        :activeCategory="activeCategory"
        :activeMiddleCategory="activeMiddleCategory"
        :catLrgCd="catLrgCd"
        :areaLrgCd="areaLrgCd"
        :areaMidCd="areaMidCd"
        :lifeGenreTags="lifeGenreTags"
        :areaSmlCd="areaSmlCd"
        :catMidCdDP="catMidCdDP"
        :catTypeDP="catTypeDP"
        :catSmlCdDP="catSmlCdDP"
        :catMidCdShop="catMidCdShop"
        :catSmlCdShop="catSmlCdShop"
      />
      <CrlyMoleculesCommonSearchKeywordCondition
        :activeCategory="activeCategory"
        @activeMidCat="changeActiveMiddleCategory"
        @catLrgCd="changeCategory"
        @areaLrgCd="changeLargeArea"
        @areaMidCd="changeArea"
        @lifeGenreTags="selectGenre"
        @areaSmlCd="changeMiddleArea"
        @catMidCdDP="changeDPMiddleCategory"
        @catSmlCdDP="changeDPSmallCategory"
        @catMidCdShop="changeShopMiddleCategory"
        @catSmlCdShop="changeShopSmallCategory"
      />
    </div>
  </section>
</template>

<script>
import CrlyAtomsCommonSearchTitle from "@crly/components/atoms/common/search/Title.vue";
import CrlyMoleculesCommonSearchKeywordCategory from "@crly/components/molecules/common/search/keyword/Category.vue";
import CrlyMoleculesCommonSearchKeywordInputForm from "@crly/components/molecules/common/search/keyword/InputForm.vue";
import CrlyMoleculesCommonSearchKeywordCondition from "@crly/components/molecules/common/search/keyword/Condition.vue";

export default {
  name: "CrlyMoleculesCommonSearchKeyword",
  components: {
    CrlyAtomsCommonSearchTitle,
    CrlyMoleculesCommonSearchKeywordCategory,
    CrlyMoleculesCommonSearchKeywordInputForm,
    CrlyMoleculesCommonSearchKeywordCondition
  },
  props: {},
  data() {
    return {
      /**
       * 選択中の特大カテゴリ
       */
      activeCategory: 1,
      /**
       * 選択中の中カテゴリ分類
       */
      activeMiddleCategory: 1,
      /**
       * 入力されたキーワード
       */
      keyword: "",
      /**
       * 選択中の大カテゴリ
       */
      catLrgCd: "",
      /**
       * 選択中のエリア
       */
      areaLrgCd: "",
      /**
       * 選択中の都道府県
       */
      areaMidCd: "",
      /**
       * 選択中のジャンル(複数)
       */
      lifeGenreTags: [],
      /**
       * 選択中の市区町村
       */
      areaSmlCd: "",
      /**
       * 選択中のDP中カテゴリ
       */
      catMidCdDP: "",
      /**
       * 選択中のDP中カテゴリタイプ
       */
      catTypeDP: null,
      /**
       * 選択中のDP小カテゴリ
       */
      catSmlCdDP: "",
      /**
       * 中カテゴリ
       */
      catMidCdShop: "",
      /**
       * 小カテゴリ
       */
      catSmlCdShop: ""
    };
  },
  methods: {
    /**
     * 特大カテゴリ変更イベント
     */
    changeActiveCategory(activeCategory) {
      this.activeCategory = activeCategory;
    },
    /**
     * 中カテゴリ分類変更イベント
     */
    changeActiveMiddleCategory(activeMiddleCategory) {
      this.activeMiddleCategory = activeMiddleCategory;
    },
    /**
     * カテゴリ変更イベント
     */
    changeCategory(catCd) {
      this.catLrgCd = catCd;
    },
    /**
     * エリア変更イベント
     */
    changeLargeArea(areaRegionCd) {
      this.areaLrgCd = areaRegionCd;
    },
    /**
     * 都道府県変更イベント
     */
    changeArea(areaCd) {
      this.areaMidCd = areaCd;
    },
    /**
     * ジャンル選択イベント
     */
    selectGenre(genreCd) {
      this.lifeGenreTags = genreCd;
    },
    /**
     * 市区町村変更イベント
     */
    changeMiddleArea(areaMiddleCd) {
      this.areaSmlCd = areaMiddleCd;
    },
    /**
     * DP中カテゴリ変更イベント
     * @param {String} catMidCd カテゴリコード
     * @param {Number} catType カテゴリタイプ
     */
    changeDPMiddleCategory(catMidCd, catType) {
      this.catMidCdDP = catMidCd;
      this.catTypeDP = catType;
    },
    /**
     * DP小カテゴリ変更イベント
     * @param {String} catSmlCd カテゴリコード
     */
    changeDPSmallCategory(catSmlCd) {
      this.catSmlCdDP = catSmlCd;
    },
    /**
     * 検索ボタンクリックイベント
     */
    clickSearchBtn() {
      const url = this.makeUrl();
      window.open(url, "_self");
    },
    /**
     * キーワード入力欄フォーカスアウトイベント
     */
    focusoutKeyword(keyword) {
      this.keyword = keyword;
    },
    /**
     * URL用パラメータを生成する
     */
    makeUrl() {
      let params = [];
      if (
        this.activeCategory === this.CONST.CATEGORY_TYPE.LIFE ||
        this.activeCategory === this.CONST.CATEGORY_TYPE.GOURMET
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.TYPE}=${this.activeCategory}`);
      } else if (this.activeCategory == this.CONST.CATEGORY_TYPE.BENE) {
        params.push(`${this.CONST.SEARCH_PARAMS.TYPE}=1`);
      } else if (this.activeCategory === this.CONST.CATEGORY_TYPE.TRAVEL) {
        if (this.activeMiddleCategory == this.CONST.MIDDLE_CATEGORY_TYPE.STAY) {
          params.push(`${this.CONST.SEARCH_PARAMS.CATEGORY}=stay`);
        } else if (
          this.activeMiddleCategory == this.CONST.MIDDLE_CATEGORY_TYPE.DP &&
          this.catTypeDP
        ) {
          params.push(`${this.CONST.SEARCH_PARAMS.TYPE}=${this.catTypeDP}`);
        }
      }
      /**
       * キーワード検索
       */
      if (this.keyword) {
        params.push(`${this.CONST.SEARCH_PARAMS.KEYWORD}=${this.keyword}`);
      }
      /**
       * カテゴリ検索
       */
      if (
        this.catLrgCd &&
        this.activeCategory === this.CONST.CATEGORY_TYPE.LIFE
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_LRG}=${this.catLrgCd}`);
      }
      /**
       * エリア検索
       */
      if (
        this.areaMidCd &&
        (this.activeCategory === this.CONST.CATEGORY_TYPE.LIFE ||
          this.activeCategory === this.CONST.CATEGORY_TYPE.GOURMET ||
          (this.activeCategory == this.CONST.CATEGORY_TYPE.TRAVEL &&
            this.activeMiddleCategory == this.CONST.MIDDLE_CATEGORY_TYPE.STAY))
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.AREA_LRG}=${this.areaLrgCd}`);
        params.push(`${this.CONST.SEARCH_PARAMS.AREA_MID}=${this.areaMidCd}`);
      }
      /**
       * ジャンル検索
       */
      if (
        this.lifeGenreTags.length !== 0 &&
        this.activeCategory === this.CONST.CATEGORY_TYPE.GOURMET
      ) {
        params.push(
          `${this.CONST.SEARCH_PARAMS.LIFE_GNR}=${this.lifeGenreTags}`
        );
      }
      /**
       * 市区町村
       */
      if (
        this.areaMidCd &&
        this.areaSmlCd &&
        this.activeCategory == this.CONST.CATEGORY_TYPE.TRAVEL &&
        this.activeMiddleCategory == this.CONST.MIDDLE_CATEGORY_TYPE.STAY
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.AREA_SML}=${this.areaSmlCd}`);
      }
      /**
       * DP中カテゴリ検索
       */
      if (
        this.catMidCdDP &&
        this.activeCategory == this.CONST.CATEGORY_TYPE.TRAVEL &&
        this.activeMiddleCategory == this.CONST.MIDDLE_CATEGORY_TYPE.DP
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_LRG}=101`);
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_MID}=${this.catMidCdDP}`);
      }
      /**
       * DP小カテゴリ検索
       */
      if (
        this.catMidCdDP &&
        this.catSmlCdDP &&
        this.activeCategory == this.CONST.CATEGORY_TYPE.TRAVEL &&
        this.activeMiddleCategory == this.CONST.MIDDLE_CATEGORY_TYPE.DP
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_SML}=${this.catSmlCdDP}`);
      }
      /**
       * 中カテゴリ検索
       */
      if (
        this.catMidCdShop &&
        this.activeCategory == this.CONST.CATEGORY_TYPE.BENE
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_LRG}=115`);
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_MID}=${this.catMidCdShop}`);
      }
      /**
       * 小カテゴリ検索
       */
      if (
        this.catMidCdShop &&
        this.catSmlCdShop &&
        this.activeCategory == this.CONST.CATEGORY_TYPE.BENE
      ) {
        params.push(`${this.CONST.SEARCH_PARAMS.CAT_SML}=${this.catSmlCdShop}`);
      }
      if (
        this.activeCategory === this.CONST.CATEGORY_TYPE.TRAVEL &&
        this.activeMiddleCategory == this.CONST.MIDDLE_CATEGORY_TYPE.DP
      ) {
        return this.makeSearchUrl("tour", params);
      }
      return this.makeSearchUrl(this.activeCategory, params);
    },
    /**
     * 中カテゴリ変更イベント
     * @param {String} catMidCd カテゴリコード
     */
    changeShopMiddleCategory(catMidCd) {
      this.catMidCdShop = catMidCd;
    },
    /**
     * 小カテゴリ変更イベント
     * @param {String} catSmlCd カテゴリコード
     */
    changeShopSmallCategory(catSmlCd) {
      this.catSmlCdShop = catSmlCd;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/search/common.scss";
</style>
